import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { SettingsBox } from 'src/Elements/Data'
import { Toggle } from 'src/Libs/inputs/formik'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useWallboxSettingsFormHelpers } from 'src/Libs/wallboxes/hooks'
import SingleToggleSettingBox from '../../../../../Elements/SystemSettings/forms/setting-boxes/SingleToggleSettingBox'

interface Props {
  model: WallboxConfigurationModel
  hasKeyLockMode?: boolean
  isKeyLockModeDisabled?: boolean
  hasRfidMode?: boolean
  rfidReaderDisabled?: boolean
  disabled?: boolean
}

const AuthFieldSet: React.FC<Props> = ({ model, hasKeyLockMode = true, hasRfidMode = true, rfidReaderDisabled = false, disabled = false }) => {
  const { t } = useCustomTranslation()
  const { keyLockModes } = useWallboxSettingsFormHelpers(model)
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box>
      <Typography variant="h2" sx={{ pt: 4, pb: 4 }}>
        {t('systemSettings.wallbox.settings.rfid.title')}
      </Typography>
      {hasKeyLockMode && (
        <Box>
          <SettingsBox
            disabled={disabled}
            title={t('systemSettings.wallbox.settings.keyLockMode.label')}
            suffix={
              <Toggle
                actions={keyLockModes.map(mode => ({ value: mode.value.toString(), label: mode.label }))}
                name="keyLockMode"
                disabled={disabled}
                fullWidth
              />
            }
            suffixSx={{ flexDirection: 'row', justifyContent: downSm ? 'flex-start' : 'flex-end', alignItems: 'center' }}
          />
        </Box>
      )}
      {hasRfidMode && (
        <SingleToggleSettingBox
          title={t('systemSettings.wallbox.settings.rfidReaderEnabled')}
          name="rfidReaderEnabled"
          disabled={rfidReaderDisabled || disabled}
        />
      )}
      {hasRfidMode && <SingleToggleSettingBox title={t('systemSettings.wallbox.settings.authRequired')} name="authRequired" disabled={disabled} />}
    </Box>
  )
}

export default AuthFieldSet
